/** @format */

import { notificationConstants } from './notifications';

export const actions = {
    success: (message) => {
        return { type: notificationConstants.SUCCESS, message: message };
    },

    error: (message) => {
        return { type: notificationConstants.ERROR, message: message };
    },

    warning: (message) => {
        return { type: notificationConstants.WARNING, message: message };
    },

    info: () => {
        return { type: notificationConstants.INFO };
    },
};

export const notificationActions = {
    enqueueSnackbar: (notification) => {
        const key = notification.options && notification.options.key;

        return {
            type: notificationConstants.ENQUEUE_SNACKBAR,
            notification: {
                ...notification,
                key: key || new Date().getTime() + Math.random(),
            },
        };
    },
    closeSnackbar: (key) => ({
        type: notificationConstants.CLOSE_SNACKBAR,
        dismissAll: !key, // dismiss all if no key has been defined
        key,
    }),
    removeSnackbar: (key) => ({
        type: notificationConstants.REMOVE_SNACKBAR,
        key,
    }),
};
